// Copyright (c) StrangeBee 2024

import { ADMIN_ORG_ID } from '@Types';
import { ProfileOutput } from 'thehive-sdk';

interface FindProfileListParams {
    orgName: string;
    profileList: ProfileOutput[];
}

export const findProfileList = ({ orgName, profileList = [] }: FindProfileListParams): ProfileOutput[] =>
    profileList.filter(
        (profile) => (profile.forAdmin && orgName === ADMIN_ORG_ID) || (profile.forOrg && orgName !== ADMIN_ORG_ID),
    );
